<!--
 * @Author: DLLCNX dllcnx@foxmail.com
 * @Date: 2023-12-26 09:56:15
 * @LastEditors: DLLCNX dllcnx@foxmail.com
 * @LastEditTime: 2023-12-27 14:56:12
 * @FilePath: /smartEarthDemo/src/demo/earth/27htmlText.vue
 * @Description: 
-->
<template>
    <div style="height:100%;">
        <div class="toolbar">
            <el-button size="small" type="primary" @click="showHtml()">HTML文本</el-button>
        </div>
        <div id="csContainer"></div>
    </div>
</template>

<script>
    import util from "../../components/util"
    import info2 from "./libs/info2"

    export default {
        data() {
            return {
                vw: null
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                let vw = util.getViewer("csContainer",{
                });
                this.vw = vw;
                vw.camera.flyTo({
                    destination: new Cesium.Cartesian3.fromDegrees(117.427308,31.82057,2000),
                    // orientation:{
                    //     heading:3,
                    //     pitch:-0.5,
                    //     roll:0
                    // }
                })
            },
            showHtml() {
                let viewer = this.vw;
                let scene = viewer.scene;
                let info22 = new info2(viewer.scene);

                function show() {
                    let lat = 40.03883;
                    let lon = -75.59777;
                    let alt = 500;

                    let ch = info22.add();
                    ch.position = Cesium.Cartesian3.fromDegrees(117.427308,31.82057,2000);

                    ch.offsetLeft = -130;
                    ch.offsetTop = -186;
                    console.log(ch,'ch')
                    ch.element.style.width = '300px';
                    ch.element.style.height = '230px';
                    ch.element.style.background = 'rgba(0, 0, 0, 0.5)';
                    ch.element.style.color="white"
                    ch.element.innerHTML =
                         "<div style='line-height:30px;height:30px;border-bottom:solid 1px white'> " +
                        "<h4 style='color:white;text-align:center'>Hello！</h4>" +
                        "<p style='text-align: justify;padding-left:15px;padding-right:15px'> &nbsp 这是一段HTML代码.</P>"
                        "</div>";
                    // setInterval(function () {
                        // Update position
                        lon = (lon + 0.001) % 180;
                        let pos = Cesium.Cartesian3.fromDegrees(117.427308,31.82057,20);
                        ch.position = pos;
                        console.log(pos)
                    // }, 200);
                }
                show();
            }
        }
    }
</script>

<style scoped>
    #csContainer {
        height: 100%;
    }
</style>
